import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { UnifiedMessageField } from 'pages/chatbot/ui/UnifiedMessageField/UnifiedMessageField'
import styles from './styles.module.scss'

export const Chat = observer(() => {
  const [value, setValue] = useState('')
  return (
    <div>
      <UnifiedMessageField
        placeholder='What should your agent do?'
        value={value}
        handleChange={setValue}
        handleSubmit={() => {}}
        disabledBtn={false}
        disabled={false}
        className={styles.messageField}
      />
    </div>
  )
})
